import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Team from '../components/Team';
import Policy from '../components/Policy';
import Footer from '../components/Footer';

export default function PolicyPage() {
  return (
    <div>
      <Header />
      <main>
        <Hero />
        <Policy />
        <Team />
      </main>
      <Footer />
    </div>
  );
}
